import { generatePath, useNavigate } from 'react-router';
import { Button, ButtonSize, ButtonVariant, Icon, IconSize, Typography } from '@shipengine/giger';
import { IconNames } from '@shipengine/giger-theme';
import { useTranslation } from '@packlink/translation-provider';
import { useCurrentInbox } from '@hooks/useCurrentInbox';
import { APP_ROUTE } from '@pages/router/routes';
import { useAmplitude } from '@hooks/useAmplitude';
import { AmplitudeEvents } from '@constants/amplitude';
import { getShipmentListMobileHeaderStyles } from './ShipmentListMobileHeaderStyles';

export function ShipmentListMobileHeader(): JSX.Element {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { inboxTranslation } = useCurrentInbox();
    const { sendAmplitudeClickEvent } = useAmplitude();

    const createNewShipment = () => {
        sendAmplitudeClickEvent(AmplitudeEvents.CREATE_SHIPMENT);
        navigate(generatePath(APP_ROUTE.CHECKOUT.STEP_INFO), { state: { isNew: true } });
    };

    return (
        <section css={getShipmentListMobileHeaderStyles}>
            <Typography variant="heading5">{inboxTranslation}</Typography>

            <Button variant={ButtonVariant.TEXT} size={ButtonSize.SMALL} onClick={createNewShipment}>
                <Icon name={IconNames.ADD} size={IconSize.SIZE_SMALL} />
                <span>{t('header.actions.new-shipment')}</span>
            </Button>
        </section>
    );
}
